import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "./Accordion"

export default function FAQ() {
  const faqs = [
    {
      question: "How does the skill matching work?",
      answer:
        "Our AI analyzes your in-game stats, rank, and playstyle preferences to find teammates that complement your strengths and help improve your weaknesses. You can also set specific preferences for the type of players you want to team up with.",
    },
    {
      question: "Is FragNades free to use?",
      answer:
        "FragNades offers a free tier with limited matches per day. Premium subscriptions provide unlimited matching, advanced filters, and priority in the matching queue.",
    },
    {
      question: "When will other games besides Valorant be supported?",
      answer:
        "We're currently focused on perfecting the experience for Valorant players. CS2, Apex Legends, and League of Legends are next on our roadmap and will be launching in the coming months.",
    },
    {
      question: "Can I link my existing Valorant account?",
      answer:
        "Yes! Linking your Valorant account allows our system to analyze your actual gameplay stats for better matching. This is optional but recommended for the best experience.",
    },
    {
      question: "How do I communicate with my matched teammates?",
      answer:
        "Once matched, you'll get access to a team chat and voice channel. You can also connect your Discord account for seamless integration with your existing communication setup.",
    },
  ]

  return (
    <section className="container mx-auto px-4 py-20">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">Frequently Asked Questions</h2>
        <p className="text-zinc-400 max-w-2xl mx-auto">Got questions? We've got answers.</p>
      </div>

      <div className="max-w-3xl mx-auto">
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`} className="border-zinc-700">
              <AccordionTrigger className="text-left hover:text-red-500">{faq.question}</AccordionTrigger>
              <AccordionContent className="text-zinc-400">{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  )
}

